import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';

import CampaignPayoutsListItem from '../item/CampaignPayoutsListItem';

import { __t, applyTranslations } from 'utils/language';

import './campaign-payouts-list-items.scss';

applyTranslations(require('./campaign-payouts-list-items.i18n.json'));

import type { PaymentConfirmationModalParams, PayoutWithHyphenAmount, Subcampaign } from 'types';

type Props = {
  headerItems: Array<string>,
  listItems: Array<PayoutWithHyphenAmount>,
  campaignId: number,
  subcampaign: Subcampaign,
  isBrand: boolean,
  isNegotiationReopened?: boolean,
  canReleasePayout?: (p: PayoutWithHyphenAmount) => boolean,
  onPayoutRelease?: () => void,
  onUnreleasePartialPayout?: (payoutId: number, campaignId: number, subcampaignId: number) => void,
  onShowConfirmationModal?: (params: PaymentConfirmationModalParams) => void,
  onHideConfirmationModal?: () => void
};

const MSG_KEY = 'campaign_payouts_list_items';

class CampaignPayoutsListItems extends React.PureComponent<Props> {
  static defaultProps = {
    isBrand: false
  };

  renderHeader(): React.ReactNode {
    const { isBrand, headerItems } = this.props;

    const headerClasses = classnames('campaign-payouts-list-header', {
      [`campaign-payouts-list-header-type-${isBrand ? 'brand' : 'influencer'}`]: true
    });

    return (
      <div
        className={headerClasses}
      >
        {
          headerItems.map(item => {
            const showTooltip = item === 'Date scheduled';

            return (
              <React.Fragment key={`campaign-payouts-list-items__${item}`}>
                <div className="campaign-payouts-list-header__column">
                  <div>
                    {item}
                  </div>
                  {
                    showTooltip && (
                      <Tooltip
                        message={__t(`${MSG_KEY}.tooltips.release_deadline`)}
                        classNameWrapper="campaign-payouts-list-items__tooltip-wrapper"
                        className="campaign-payouts-list-items__tooltip"
                        showQuestionMark
                      />
                    )
                  }
                </div>
              </React.Fragment>
            );
          })
        }
      </div>
    );
  }

  render(): React.ReactNode {
    const {
      listItems,
      isBrand,
      campaignId,
      subcampaign,
      isNegotiationReopened,
      canReleasePayout,
      onPayoutRelease,
      onUnreleasePartialPayout,
      onShowConfirmationModal,
      onHideConfirmationModal
    } = this.props;

    return (
      <section
        className="campaign-payouts-list-items"
        data-qa="campaign-payouts-list-items"
      >
        {this.renderHeader()}
        {
          listItems.map((item, index) => (
            <CampaignPayoutsListItem
              key={`payout-${String(item.id)}`}
              payout={item}
              position={index}
              campaignId={campaignId}
              subcampaign={subcampaign}
              isBrand={isBrand}
              isNegotiationReopened={isNegotiationReopened}
              canReleasePayout={canReleasePayout}
              onPayoutRelease={onPayoutRelease}
              onUnreleasePartialPayout={onUnreleasePartialPayout}
              onShowConfirmationModal={onShowConfirmationModal}
              onHideConfirmationModal={onHideConfirmationModal}
            />
          ))
        }
      </section>
    );
  }
}

export default CampaignPayoutsListItems;
